// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__34x2l","ranges":"BmiRanges_ranges__2cP1r"};